import { Observable } from "rxjs";
import { combineEpics } from "redux-observable";

import st from "lib/utils/index";
import { CompanyMembersRepository } from "lib/repositories/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "settings/CompanyMembersView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "settings/CompanyMembersView/DESTROY_VIEW";
export const LOAD_MEMBERS = "settings/CompanyMembersView/LOAD_MEMBERS";
export const FETCH_MEMBERS = "settings/CompanyMembersView/FETCH_MEMBERS";
export const FETCH_MEMBERS_START = "settings/CompanyMembersView/FETCH_MEMBERS_START";
export const FETCH_MEMBERS_SUCCESS = "settings/CompanyMembersView/FETCH_MEMBERS_SUCCESS";
export const FETCH_MEMBERS_FAILURE = "settings/CompanyMembersView/FETCH_MEMBERS_FAILURE";
export const CHANGE_PAGINATION = "settings/CompanyMembersView/CHANGE_PAGINATION";
export const SET_PAGINATION = "settings/CompanyMembersView/SET_PAGINATION";
export const SET_SEARCH = "settings/CompanyMembersView/SET_SEARCH";

export const stateSelector = (state) => state.settings.CompanyMembersView;

const resourceInstance = createResourceInstance({
  LOAD: LOAD_MEMBERS,
  FETCH: FETCH_MEMBERS,
  FETCH_START: FETCH_MEMBERS_START,
  FETCH_SUCCESS: FETCH_MEMBERS_SUCCESS,
  FETCH_FAILURE: FETCH_MEMBERS_FAILURE,
  stateSelector,
  stateKey: "members",
  getModel: ({ offset, limit, search }) => {
    const page = offset / limit + 1;
    const params = { page, per: limit };
    if (search) params.search = search;
    return CompanyMembersRepository.findAll(params);
  },
});

const limit = parseInt(localStorage.getItem("membersLimit"), 10) || 20;

const initialState = {
  members: resourceInstance.initialState,
  offset: 0,
  limit: limit,
  search: "",
};

const reducers = {
  ...resourceInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,

  [SET_PAGINATION]: (state, { offset = state.offset, limit = state.limit }) => ({
    ...state,
    offset,
    limit,
  }),

  [SET_SEARCH]: (state, { search }) => ({
    ...state,
    search,
    offset: 0,
  }),
};

const viewEpics = [
  ...resourceInstance.epics,

  (actions$) => Observable.of(fetchMembers()),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).map(({ offset, limit }) => setPagination({ offset, limit })),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).debounceTime(300).mapTo(fetchMembers()),

  (actions$) => actions$.ofType(SET_SEARCH).debounceTime(400).mapTo(fetchMembers()),
];

const epics = [
  (actions$, store) =>
    actions$
      .ofType(INITIALIZE_VIEW)
      .concatMap(() => combineEpics(...viewEpics)(actions$, store).takeUntil(actions$.ofType(DESTROY_VIEW))),
];

export const { load: loadMembers, fetch: fetchMembers } = resourceInstance.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export function destroyView() {
  return { type: DESTROY_VIEW };
}

export function changePagination({ offset, limit }) {
  return { type: CHANGE_PAGINATION, offset, limit };
}

export function setPagination({ offset, limit }) {
  return { type: SET_PAGINATION, offset, limit };
}

export function setSearch(search) {
  return { type: SET_SEARCH, search };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/CompanyMembersView/index.js